<template>
  <div class="content_page">
    <Tabbar :title="$t('withdrawAccount.bindThirdPartyTitle', ['PayPal'])"></Tabbar>
    <WithdrawStepper v-if="fromBasicLevel" />
    <div class="content_area">
      <Tip :content="$t('withdrawAccount.bindNote')" />
      <div class="content_item">
        <CommonFormItem :label="$t('account.account')" required>
          <CommonInput v-model="account" theme="white" type="text" />
        </CommonFormItem>
      </div>
      <div v-if="needPayoutAddress" class="content_item">
        <CommonFormItem :label="$t('bankData.city')" required>
          <CommonInput v-model="city" theme="white" type="text" />
        </CommonFormItem>
      </div>
      <div v-if="needPayoutAddress" class="content_item">
        <CommonFormItem :label="$t('bankData.postalCode')" required>
          <CommonInput
            v-model="postalCode"
            theme="white"
            type="tel"
            :onInput="($event) => validatePostalCode($event)"
          />
        </CommonFormItem>
      </div>
      <div v-if="needPayoutAddress" class="content_item">
        <CommonFormItem label="addressLine" required>
          <CommonInput v-model="addressLine" theme="white" type="text" />
        </CommonFormItem>
      </div>
      <div class="done_btn_area">
        <CommonBtn class="done_btn" :text="$t('common.done')" :on-click="bindThirdPartyPay" />
      </div>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import WithdrawStepper from '@/components/WithdrawStepper.vue'
import CommonFormItem from '@/components/CommonFormItem'
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import Tip from '@/components/LinkAccount/Tip'
import { Toast } from 'vant'
import debounce from 'lodash/debounce'

export default {
  name: 'BindThirdPartyPayAccount',
  components: {
    Tabbar,
    WithdrawStepper,
    CommonFormItem,
    CommonInput,
    CommonBtn,
    Tip
  },
  data() {
    return {
      channel: '',
      account: '',
      withdrawType: undefined,
      isShow: false,
      city: '',
      postalCode: '',
      addressLine: '',
      binding: false
    }
  },
  computed: {
    fromBasicLevel() {
      return this.$route.query.from === 'BasicLevel'
    },
    // 美国 countryNo=213 不需要地址字段，其它地区仍需要
    needPayoutAddress() {
      return this.withdrawType === 20 && Number(this.$store.state.userInfo.countryNo) !== 213
    }
  },
  mounted() {
    if (this.$route.params.account) {
      this.account = this.$route.params.account
    }
    switch (this.$route.name) {
      case 'BindNewPayPal':
        this.channel = 'PayPal'
        this.withdrawType = 15
        break
      case 'BindPayoutPayPal':
        this.channel = 'PayPal'
        this.withdrawType = 20
        break
      default:
        break
    }
  },
  watch: {
    account: function (value) {
      this.isShow = true
    }
  },
  methods: {
    validatePostalCode(event) {
      // 禁止输入符号空格
      const inputValue = event.target.value
      const regex = /^[0-9]+$/
      this.$nextTick(() => {
        if (!regex.test(inputValue)) {
          this.postalCode = inputValue.replace(/[^0-9]/g, '')
        }
      })
    },
    bindThirdPartyPay: debounce(
      function () {
        const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (!this.account) {
          Toast(this.$t('withdrawAccount.accountEmptyToast'))
          return
        }
        if (!regEmail.test(this.account)) {
          Toast(this.$t('loginAndRegister.emailFormatToast'))
          return
        }
        if (this.needPayoutAddress && (!this.city || !this.postalCode || !this.addressLine)) {
          Toast(this.$t('basicLevel.fieldEmptyToast'))
          return
        }
        if (this.binding) return
        this.binding = true
        const data = {
          account: this.account,
          withdrawType: this.withdrawType
        }
        // 非美国地区 payout paypal 补充地址字段
        if (this.needPayoutAddress) {
          data.city = this.city
          data.postalCode = this.postalCode
          data.addressLine = this.addressLine
        }
        this.$http
          .post(window.serverPath + '/api/account/bindThirdPartyPay', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (this.$route.query.from === 'BasicLevel') {
                this.$router.replace({ name: 'Withdrawal' })
              } else if (this.$route.query.hasOwnProperty('redirect')) {
                this.$router.replace({ name: this.$route.query.redirect })
              } else {
                this.$router.back()
              }
            } else {
              Toast(res.data.message)
            }
          })
          .catch((err) => console.log(err))
          .finally(() => (this.binding = false))
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
}

.content_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content_area {
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
}

.content_item {
  width: 100%;
  margin-bottom: 0.12rem;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eeeef7;
  padding: 0.18rem;
  background: #ffffff;
}

.done_btn {
  font-size: 0.16rem !important;
  width: 100% !important;
}
/* new */

.required_icon {
  width: 0.08rem;
  height: 0.08rem;
}

.next_btn {
  margin-top: 0.28rem;
  width: 100% !important;
  font-size: 0.16rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/BindNewPayPal.vue